(function ($) {
  const SECTION_SELECTOR = '.it-why-most-website-fails';
  const WRAPPER_SELECTOR = '.why-most-website-fails__card-wrapper';
  const CARD_SELECTOR = '.why-most-website-fails__block';
  const DESKTOP_TOP = 60;
  const DESKTOP_STEP = 20;
  const MOBILE_TOP = 72;
  const MOBILE_STEP = 0;
  const PROGRESS_DISTANCE = 420;
  const SCALE_STEP = 0.06;
  const BLUR_STEP = 2.3;
  const TYPE_SPEED = 85;
  const BASE_BG = [239, 236, 225];
  const DARK_BG = [176, 166, 138];

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function isMobile() {
    return window.innerWidth <= 576;
  }

  function rgb(color) {
    return 'rgb(' + color.join(', ') + ')';
  }

  function mixColor(from, to, amount) {
    return from.map((channel, index) => Math.round(channel + ((to[index] - channel) * amount)));
  }

  function prepareTypedSpan(section) {
    const title = section.querySelector('.why-most-website-fails__title');

    if (!title) {
      return null;
    }

    const span = title.querySelector('span');

    if (!span) {
      return null;
    }

    const source = span.textContent || '';

    if (!source) {
      return null;
    }

    span.dataset.typedSource = source;
    span.innerHTML = '';

    return span;
  }

  function typeSpan(span) {
    if (!span || span.dataset.typedStarted === 'true') {
      return;
    }

    const source = span.dataset.typedSource || '';

    if (!source) {
      return;
    }

    span.dataset.typedStarted = 'true';

    let charIndex = 0;

    function tick() {
      charIndex += 1;
      span.textContent = source.slice(0, charIndex);

      if (charIndex < source.length) {
        window.setTimeout(tick, TYPE_SPEED);
        return;
      }
    }

    tick();
  }

  function getTop(index) {
    return isMobile() ? MOBILE_TOP + (MOBILE_STEP * index) : DESKTOP_TOP + (DESKTOP_STEP * index);
  }

  function prepareCard(wrapper, card, index, total) {
    wrapper.style.position = 'sticky';
    wrapper.style.top = getTop(index) + 'px';
    wrapper.style.zIndex = String(index + 1);
    wrapper.style.width = '100%';

    card.style.transformOrigin = 'top center';
    card.style.willChange = 'transform, filter';
    card.style.position = 'relative';
    card.style.transform = 'scale(1)';
    card.style.filter = 'blur(0px)';
    card.style.backgroundColor = rgb(BASE_BG);

    if (index === total - 1) {
      card.style.filter = 'blur(0px)';
    }
  }

  function updateSection(section) {
    const cards = section.querySelectorAll(CARD_SELECTOR);
    const total = cards.length;

    cards.forEach((card, index) => {
      const rect = card.getBoundingClientRect();
      const triggerTop = getTop(index);
      const progress = clamp((triggerTop + 120 - rect.top) / PROGRESS_DISTANCE, 0, 1);
      const depth = total - index - 1;
      const scaleDelta = isMobile() ? 0 : depth * SCALE_STEP;
      const blurValue = index === total - 1 ? 0 : depth * BLUR_STEP * progress;
      const scaleValue = 1 - (scaleDelta * progress);
      const bgProgress = index === total - 1 ? 0 : Math.min(depth * progress * 0.32, 1);

      card.style.transform = 'scale(' + scaleValue.toFixed(3) + ')';
      card.style.filter = 'blur(' + blurValue.toFixed(2) + 'px)';
      card.style.backgroundColor = rgb(mixColor(BASE_BG, DARK_BG, bgProgress));
    });
  }

  function initSection(section) {
    const wrappers = section.querySelectorAll(WRAPPER_SELECTOR);
    const cards = section.querySelectorAll(CARD_SELECTOR);
    const typedSpan = prepareTypedSpan(section);
    
    if (!wrappers.length || wrappers.length !== cards.length) {
      return;
    }

    cards.forEach((card, index) => {
      prepareCard(wrappers[index], card, index, cards.length);
    });

    section.classList.add('is-reveal-ready');

    const fadeElements = section.querySelectorAll('.fade-up');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-visible');

        if (typedSpan && entry.target.matches('.why-most-website-fails__title')) {
          window.setTimeout(() => {
            typeSpan(typedSpan);
          }, 180);
        }

        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.18,
      rootMargin: '0px 0px -8% 0px',
    });

    fadeElements.forEach((element, index) => {
      element.style.transitionDelay = `${index * 90}ms`;
      observer.observe(element);
    });

    let ticking = false;

    function requestUpdate() {
      if (ticking) {
        return;
      }

      ticking = true;

      window.requestAnimationFrame(() => {
        updateSection(section);
        ticking = false;
      });
    }

    requestUpdate();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  $(function () {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      initSection(section);
    });
  });
})(jQuery);
